import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons/faDoorOpen';
import { faEye } from '@fortawesome/free-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';

import { useHttpStatus } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import Modal from '~/commons/components/Modal.jsx';

const schema = object().shape({
  email: string()
    .trim()
    .lowercase()
    .email('必須為有效電郵地址')
    .required('必填'),
  password: string()
    .required('必填'),
});
const defaults = {
  email: '',
  password: '',
};

const FormLogin = ({
  title = '',
  router = true,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [persist, setPersist] = useState(true);
  const [res, req] = useHttpStatus({
    onSuccess() {
      window.location.replace('/app');
    },
  });

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="sm"
      >
        <h5 className="p-4">
          個人帳戶將於 10月12日（星期一）早上十時開始接受申請。
        </h5>
        <button
          className="btn btn-primary btn-block"
          onClick={() => setShowModal(false)}
        >
          OK
        </button>
      </Modal>
      <div className="form-login-box">
        <div className="form-login-title">登入</div>
        <Formik
          validationSchema={schema}
          initialValues={defaults}
          onSubmit={(values) => req({
            method: 'post',
            url: '/api/core/auth',
            data: {
              ...values,
              web: 1,
              persist,
            },
          })}
        >
          <Form>
            <FormHttpAlert res={res} />
            <FormGroup
              name="email"
              label={null}
              placeholder="請輸入帳號"
              className="form-login-input"
            />
            <FormGroup
              name="password"
              type={showPwd ? 'text' : 'password'}
              label={null}
              placeholder="請輸入密碼"
              className="form-login-input"
              append={(
                <button
                  type="button"
                  className="btn btn-outline-dark pwd-visibility"
                  onClick={() => setShowPwd(!showPwd)}
                >
                  <FA icon={showPwd ? faEyeSlash : faEye} />
                </button>
              )}
            />
            <div className="form-login-checkbox">
              <input
                type="checkbox"
                id="persist"
                checked={persist}
                onChange={() => setPersist(!persist)}
              />
              <label htmlFor="persist">保持登入</label>
            </div>
            <button
              type="submit"
              className="form-login-btn"
            >
              登入
            </button>
          </Form>
        </Formik>
      </div>
    </>
  );
};

export default FormLogin;
